<div class="container">
    <div class="row"><div class="col-12"><h3 style="color:#719eb6">BIP - Quick Reference</h3></div></div>
    <div *ngIf="loading()">
      <div class="d-flex justify-content-center p-3">
        <div class="spinner-border text-primary" role="status" aria-label="Loading">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
    <ng-container *ngIf="!loading()">
    <div class="row mb-4" style="color:#222;">
      <div class="col-12">
        <article class="sheet" role="document" aria-label="Quick Reference">
  
          <!-- Top header meta -->
          <section class="section pt-3 pb-2">
            <table class="table table-bordered mb-0" style="border-color: var(--line, #cfcfcf);">
              <tbody>
                <tr>
                  <th style="width:160px; background:#f0f0f0;">Client Name</th>
                  <td>{{clientName()}}</td>
                  <th style="width:160px; background:#f0f0f0;">Age and DOB</th>
                  <td>{{ageAndDOB()}}</td>
                </tr>
                <!-- <tr>
                  <th style="background:#f0f0f0;">Clinician Team</th>
                  <td colspan="3">{{clinicianTeam()}}</td>
                </tr> -->
              </tbody>
            </table>
          </section>
  
          <!-- Quick Reference -->
          <section class="section pt-2 pb-3">
            @if (shouldShowToggle()) {
            <div class="d-flex justify-content-start align-items-center mb-2">
              <p-selectButton [options]="[
                { label: 'Draft', value: false },
                { label: 'Current', value: true }
              ]" [ngModel]="isCurrentView" (onChange)="onViewChange($event)" autoWidth="false"></p-selectButton>
              <span class="ms-2">{{ isCurrentView ? 'Viewing Current' : 'Viewing Draft' }}</span>
            </div>
            }
            <table class="table table-bordered mb-0" style="border-color: var(--line, #cfcfcf);">
              <thead>
                <tr style="background:#e9e9ee;">
                  <th colspan="4" class="text-center" style="font-weight:700;">Quick Reference</th>
                </tr>
                <tr>
                  <th style="width:160px;">Behavior</th>
                  <th style="width:220px;">Function(s)</th>
                  <th style="width:40px;" class="text-center"> </th>
                  <th>Strategy</th>
                </tr>
              </thead>
              <tbody>
  
                
                <tr *ngFor="let behavior of behaviors()">
                  <!-- Behavior -->
                  <td class="align-middle text-center">
                    <strong><a href="javascript:void(0)">{{behavior.name}}</a></strong>
                  </td>
  
                  <!-- Functions: full-height stack -->
                  <td class="align-top p-0 position-relative">
                    <div class="position-absolute top-0 bottom-0 start-0 end-0 d-flex flex-column">
                      <div *ngFor="let function of behavior.functions" class="d-flex flex-column align-items-center justify-content-center text-center fw-bold"
                           style="min-height:48px; border-bottom:1px solid var(--line,#cfcfcf); flex:1;" [ngClass]="function.class">
                        <span *ngIf="function.roleLabel" style="font-size:11px;text-transform:uppercase;">{{function.roleLabel}}</span>
                        <span>{{function.name}}</span>
                      </div>
                    </div>
                  </td>
  
                  
                  <td colspan="2" class="p-0">
                    <div style="display:grid; grid-template-columns:40px 1fr; border-bottom:1px solid var(--line,#cfcfcf);">
                      <div class="d-flex align-items-center justify-content-center fw-bold bg-green-2">A</div>
                      <div class="bg-green p-2">
                        <ul class="mb-0">
                          <li *ngFor="let antecedent of behavior.antecedents"><a href="javascript:void(0)" (click)="goToStrategy('A', behavior.id, antecedent)">{{antecedent.name}}</a></li>
                        </ul>
                      </div>
                    </div>
                    <div style="display:grid; grid-template-columns:40px 1fr; border-bottom:1px solid var(--line,#cfcfcf);">
                      <div class="d-flex align-items-center justify-content-center fw-bold bg-yellow-2">R</div>
                      <div class="bg-yellow p-2">
                        <ul class="mb-0">
                            <li *ngFor="let replacement of behavior.replacements"><a href="javascript:void(0)" (click)="goToStrategy('R', behavior.id, replacement)">{{replacement.name}}</a></li>
                        </ul>
                      </div>
                    </div>
                    <div style="display:grid; grid-template-columns:40px 1fr;">
                      <div class="d-flex align-items-center justify-content-center fw-bold bg-red-2">C</div>
                      <div class="bg-red p-2">
                        <ul class="mb-0">
                            <li *ngFor="let consequence of behavior.consequences"><a href="javascript:void(0)" (click)="goToStrategy('C', behavior.id, consequence)">{{consequence.name}}</a></li>
                        </ul>
                      </div>
                    </div>
                  </td>
                </tr>
  
                
  
              </tbody>
            </table>
          </section>
  
        </article>
      </div>
    </div>
    </ng-container>
  </div>
  